import { createRoot } from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import { initSentry } from "./lib/sentry";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";
import { checkOtaCrashGuard } from "./lib/ota-updater";

window.addEventListener('error', (e) => {
  console.error('[GlobalError]', e.error || e.message);
});
window.addEventListener('unhandledrejection', (e) => {
  console.error('[UnhandledRejection]', e.reason);
});

const isIPadDevice = () =>
  navigator.userAgent.includes('iPad') ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ||
  (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);

const hideHtmlLoader = () => {
  const loader = document.getElementById('app-loader');
  if (!loader || loader.classList.contains('hide')) return;

  loader.classList.add('hide');
  window.setTimeout(() => loader.remove(), 400);
};

if (Capacitor.isNativePlatform()) {
  // Detect OTA crash loops early on Android.
  // We intentionally do NOT call notifyAppReady here: confirmation must wait
  // until React has stayed stable long enough to trust the updated bundle.
  if (Capacitor.getPlatform() === 'android') {
    checkOtaCrashGuard();
  }

  const forceHideSplash = async () => {
    try {
      const { SplashScreen } = await import("@capacitor/splash-screen");
      await SplashScreen.hide({ fadeOutDuration: 200 });
    } catch {}
  };

  if (isIPadDevice()) {
    forceHideSplash();
    setTimeout(forceHideSplash, 500);
    setTimeout(forceHideSplash, 1500);
    setTimeout(forceHideSplash, 3000);
  } else {
    setTimeout(forceHideSplash, 3000);
  }
}

initSentry();

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(<App />);

if (rootElement.childElementCount > 0) {
  requestAnimationFrame(hideHtmlLoader);
} else {
  const observer = new MutationObserver(() => {
    if (rootElement.childElementCount === 0) return;
    observer.disconnect();
    requestAnimationFrame(hideHtmlLoader);
  });

  observer.observe(rootElement, { childList: true });

  window.setTimeout(() => {
    observer.disconnect();
    if (rootElement.childElementCount > 0) {
      hideHtmlLoader();
    }
  }, 10000);
}
